import { makeStyles, Theme } from "@material-ui/core";
import {
  getRelativeFontSize,
  regularFont,
} from "../../../utils/styles";

const customNotificationStyles = makeStyles(
  (theme: Theme) => ({
    iconBlock: {
      height: "100%",
      width: "10%",
      display: "flex",
      alignItems: "flex-start",
    },
    notificationTitle: {
      fontSize: getRelativeFontSize(4),
    },
    messageBox: {
      ...regularFont,
      paddingTop: "5px",
      fontSize: getRelativeFontSize(2),
      wordBreak: "break-word",
    },
    messageContainer: {
      width: "80%",
    },
    closeNotification: {
      cursor: "pointer",
      // float: "right",
    },
  }),
  { index: 1 }
);

export default customNotificationStyles;
